import useGetAllDocuments from '@/services/hooks/useGetAllDocuments'
import {
  constructDynamicFilters,
  constructFieldOrdering,
  UseDocumentGridOptions,
} from './useDocumentGrid'

type UseDocumentDashboardIdsOptions = Omit<
  UseDocumentGridOptions,
  'projectGridIds' | 'limit' | 'queryBy'
> & {
  enabled: boolean
}

export default function useDocumentDashboardIds({
  projectId,
  refetchInterval,
  workflowStateId,
  noFlags,
  flagCodes,
  filtering,
  ordering,
  orgIds,
  teamIds,
  tagIds,
  workflowId,
  enabled,
}: UseDocumentDashboardIdsOptions) {
  const query = useGetAllDocuments({
    filters: {
      project_id: projectId,
      ...constructDynamicFilters(
        'document',
        filtering || [],
        workflowStateId,
        workflowId,
      ),
      ordering: constructFieldOrdering('document', ordering),
      self_and_descendants_of_owner_org_id__in: orgIds
        ? orgIds.join()
        : undefined,
      team_id__in: teamIds?.join(),
      fields__only: 'id',
      no_flags: !flagCodes && noFlags ? 'true' : undefined,
      any_flag__flag_level__in: flagCodes?.join(),
      doc_project_tags__project_tag_id__in: tagIds?.join(),
      limit: '200',
    },
    refetchInterval,
    enabled,
  })

  return query
}
